export default __webpack_public_path__ + "static/media/Animations_Bar2.a00f1ce8.svg";